export enum ItemOrigin {
    EXISTING,
    COPIED,
    NEW,
    PREPARED_DEFAULT,
}
